@if (tabsMode() === false) {
  <igo-list [navigation]="true">
    @for (group of results$ | async; track group) {
      @if (mode() === searchResultMode.Grouped) {
        <igo-collapsible
          [class]="group.source.getId()"
          [title]="computeGroupTitle(group)"
          [collapsed]="collapsed[group.source.title]"
          (toggle)="collapsed[group.source.title] = $event"
        >
          <ng-container
            *ngTemplateOutlet="
              storeItemTemplate;
              context: { results: group.results }
            "
          />
        </igo-collapsible>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            storeItemTemplate;
            context: { results: group.results }
          "
        />
      }

      <ng-template #storeItemTemplate let-results="results">
        @for (result of results; track result) {
          <igo-search-results-item
            igoListItem
            color="accent"
            [map]="map()"
            [result]="result"
            [showIcons]="showIcons()"
            [withZoomButton]="withZoomButton()"
            [focused]="store().state.get(result).focused"
            [selected]="store().state.get(result).selected"
            (focus)="resultFocus.emit(result)"
            (unfocus)="resultUnfocus.emit(result)"
            (select)="onResultSelect(result)"
            (mouseenter)="resultFocus.emit(result)"
            (mouseleave)="resultUnfocus.emit(result)"
          >
            <ng-container
              igoSearchItemToolbar
              [ngTemplateOutlet]="templateSearchToolbar()"
              [ngTemplateOutletContext]="{ result: result }"
            />
          </igo-search-results-item>
        }
        @if (isMoreResults(group)) {
          <span class="moreResults" (click)="displayMoreResults(group)">
            <u>{{ 'igo.geo.search.displayMoreResults' | translate }}</u>
          </span>
        }
      </ng-template>
    }
  </igo-list>
}

@if (tabsMode()) {
  <igo-list [navigation]="true">
    @if (mode() === searchResultMode.Grouped) {
      <mat-tab-group class="custom-tabs-view" dynamicHeight>
        @for (group of results$ | async; track group) {
          <mat-tab [label]="computeGroupTitle(group)">
            <ng-container
              *ngTemplateOutlet="storeItemTemplate; context: { group: group }"
            />
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      @for (group of results$ | async; track group) {
        <ng-container
          *ngTemplateOutlet="storeItemTemplate; context: { group: group }"
        />
      }
    }

    <ng-template #storeItemTemplate let-group="group">
      @for (result of group.results; track result) {
        <igo-search-results-item
          igoListItem
          color="accent"
          [map]="map()"
          [result]="result"
          [showIcons]="showIcons()"
          [withZoomButton]="withZoomButton()"
          [focused]="store().state.get(result).focused"
          [selected]="store().state.get(result).selected"
          (focus)="resultFocus.emit(result)"
          (unfocus)="resultUnfocus.emit(result)"
          (select)="onResultSelect(result)"
          (mouseenter)="resultFocus.emit(result)"
          (mouseleave)="resultUnfocus.emit(result)"
        >
          <ng-container
            igoSearchItemToolbar
            [ngTemplateOutlet]="templateSearchToolbar()"
            [ngTemplateOutletContext]="{ result: result }"
          />
        </igo-search-results-item>
      }

      @if (isMoreResults(group)) {
        <span class="moreResults" (click)="displayMoreResults(group)">
          <u>{{ 'igo.geo.search.displayMoreResults' | translate }}</u>
        </span>
      }
    </ng-template>
  </igo-list>
}
